import { render } from "./KanaTable.vue?vue&type=template&id=330755fa"
import script from "./KanaTable.vue?vue&type=script&lang=js"
export * from "./KanaTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/kana-hangul-fo/kana-hangul-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__